'use strict';

import angular from 'angular';

import modalDirective from 'brg/rest/buttons/modal';

import addTemplate from './add.html';
import servproAddTemplate from './servpro-add.html';

const MODULE_NAME = 'daupler.incidents.components.buttons.incident';

var app = angular.module(MODULE_NAME, [
]);

app.directive('addIncident', modalDirective({
	template: addTemplate,
}));

app.directive('addServproJob', modalDirective({
	template: servproAddTemplate,
}));

export default MODULE_NAME;
